
























import Vue from 'vue'
import WithTooltip from '@/ui/tooltip/WithTooltip.vue'

export default Vue.extend({
  name: 'TooltipCell',
  components: {
    WithTooltip,
  },
  props: {
    title: { type: String, required: true },
    rowId: { type: Number, required: true },
  },
  methods: {
    handleRightClick(event: any) {
      event.preventDefault()
      this.$emit('onRightClick', { data: { id: this.$props.rowId }, event })
    },
  },
  mounted() {
    const container = document.querySelector(`#cell-${this.$props.rowId}`)
    container && container.addEventListener('contextmenu', this.handleRightClick)
  },
  beforeDestroy() {
    const container = document.querySelector(`#cell-${this.$props.rowId}`)
    container && container.removeEventListener('contextmenu', this.handleRightClick)
  },
})
